import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";

import { getUserNameForAvatar, addLandaSize } from "Utils";
import { TTP_API_URL } from "Config";
import Controls from "./Controls";
import { updateUsersSettings, updateGeneralSettings } from "Thunks";
import { initSaveUsers, closeSidebar, setSelectedUsers } from "Actions";
import Switch from "Common/Switch/Switch/Switch";

import _ from "i18n";
import { getAllowedLanguages } from "../../utils";

const defaultState = {
  types: {
    IMAGE: "",
    VIDEO: "",
    PDF: "",
    PPT: ""
  },
  role: "",
  type: "",
  generalTypes: [],
  languages: [],
  publicProfile: false,
  defaultData: {
    copyright: ""
  },
  allowedLanguages: [],
  allowedType: []
};

export class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.state = defaultState;
  }

  componentDidMount() {
    const { users, selectedIds } = this.props;

    if (selectedIds.length === 1) {
      const user = users.filter(user => selectedIds.indexOf(user.id) > -1);
      if (
        user.blogRoleInOrganization &&
        user.blogRoleInOrganization.length > 0 &&
        user.blogRoleInOrganization[0].role
      ) {
        this.setState = {
          role: user.blogRoleInOrganization[0].role
        };
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedIds, users, opened, navCommunity } = this.props;

    // Reset state when sidebar is closed
    if (opened === false && prevProps.opened === true) {
      return this.setState({ ...defaultState });
    }

    // General Settings
    if (
      opened === true &&
      prevProps.opened === false &&
      selectedIds &&
      selectedIds.length === 0
    ) {
      const { mediaSettings } = navCommunity;
      const preferences = mediaSettings && mediaSettings.preferences;

      if (preferences) {
        const defaultData = preferences.defaultData
          ? JSON.parse(preferences.defaultData)
          : {};
        const publicProfile = preferences.publicProfile
          ? JSON.parse(preferences.publicProfile)
          : 1;
        const languages = preferences.languages
          ? preferences.languages.split(",")
          : [];
        const generalTypes = preferences.generalTypes
          ? preferences.generalTypes.split(",")
          : [];

        this.setState({
          languages,
          generalTypes,
          defaultData,
          allowedLanguages: ["EN", "FR", "NL"],
          publicProfile: publicProfile === 1
        });
      }
    }

    if (
      opened === true &&
      prevProps.opened === false &&
      selectedIds &&
      selectedIds.length === 1
    ) {
      // set state from user pref
      // const user = selectedUsers[0];
      const user = users.find(user => selectedIds.indexOf(user.id) > -1);
      const communities = user.communities || [];
      const community = communities.find(c => c.id === navCommunity.id);
      const roles =
        community && community.mediaSettings && community.mediaSettings.roles;
      const types = {
        IMAGE: (roles && roles.imageRole) || "",
        VIDEO: (roles && roles.videoRole) || "",
        PDF: (roles && roles.pdfRole) || "",
        PPT: (roles && roles.pptRole) || ""
      };
      let role = this.state.role;
      if (
        user.blogRoleInOrganization &&
        user.blogRoleInOrganization.length > 0 &&
        user.blogRoleInOrganization[0].role
      ) {
        role = user.blogRoleInOrganization[0].role;
        if (role === "REDACTOR" || role === "AUTHOR")
          role += user.blogRoleInOrganization[0].mandated ? "_1" : "_0";
      }

      const { mediaSettings } = navCommunity;
      const preferences = mediaSettings && mediaSettings.preferences;

      const allowedLanguages =
        preferences && preferences.languages
          ? preferences.languages.split(",")
          : [];
      const allowedGeneralTypes =
        preferences && preferences.generalTypes
          ? preferences.generalTypes.split(",")
          : [];
      let allowedType = allowedGeneralTypes.filter(
        type => type !== "PDF" && type !== "PPT"
      );

      if (
        allowedGeneralTypes.includes("PDF") &&
        allowedGeneralTypes.includes("PPT")
      )
        allowedType.push("DOCUMENTS");

      const userLanguages =
        (roles &&
          roles.preferences &&
          roles.preferences.languages &&
          roles.preferences.languages.split(",")) ||
        [];
      this.setState({
        languages: userLanguages.filter(lng => allowedLanguages.includes(lng)),
        role,
        types,
        allowedType,
        allowedLanguages
      });
    }
  }

  init() {
    this.props.dispatch(closeSidebar());
    this.props.dispatch(initSaveUsers());
    this.props.dispatch(setSelectedUsers([]));
  }

  saveSettings() {
    const { selectedIds } = this.props;
    const {
      languages,
      types,
      defaultData,
      publicProfile,
      generalTypes
    } = this.state;

    if (!selectedIds || selectedIds.length === 0) {
      return this.props.dispatch(
        updateGeneralSettings({
          languages,
          generalTypes,
          defaultData,
          publicProfile
        })
      );
    }

    this.props.dispatch(
      updateUsersSettings({
        languages,
        types,
        usersIds: selectedIds,
        defaultData,
        publicProfile
      })
    );
  }

  renderSingleUser(user) {
    const {
      firstName,
      lastName,
      avatar,
      avatarUrl,
      role,
      blogRoleInOrganization,
      defaultSignature,
      header
    } = user;

    let avatarDiv = null;
    if (avatar || avatarUrl) {
      avatarDiv = (
        <div
          className="author-avatar"
          style={{
            backgroundImage: `url(${
              avatarUrl
                ? addLandaSize(avatarUrl, 260)
                : TTP_API_URL + "/" + avatar
            })`
          }}
        />
      );
    } else {
      avatarDiv = (
        <div className="author-avatar empty-avatar">
          <span>{getUserNameForAvatar(firstName, lastName)}</span>
        </div>
      );
    }

    let defaultSignatureDiv = [];
    if (defaultSignature && defaultSignature !== "" && defaultSignature.title) {
      defaultSignatureDiv.push(<h3 key="sh3">{defaultSignature.title}</h3>);
    } else {
      defaultSignatureDiv.push(<h3 key="sh3">{firstName + " " + lastName}</h3>);
    }
    if (blogRoleInOrganization && blogRoleInOrganization.length > 0) {
      defaultSignatureDiv.push(
        <h4 key="sh4">
          <span>
            {_(blogRoleInOrganization[0].role)}
            {blogRoleInOrganization[0].role !== "CHIEF_EDITOR" && (
              <span className="mandated">
                ({blogRoleInOrganization[0].mandated === 0
                  ? _("Not Mandated")
                  : _("Mandated")})
              </span>
            )}
          </span>
        </h4>
      );
    } else if (role && role.id !== undefined) {
      defaultSignatureDiv.push(<h4 key="sh4">{role.type}</h4>);
    }
    if (defaultSignature && defaultSignature !== "" && defaultSignature.head) {
      defaultSignatureDiv.push(<h5 key="sh5">{defaultSignature.head}</h5>);
    } else if (header) {
      defaultSignatureDiv.push(<h5 key="sh5">{header}</h5>);
    }
    return (
      <div className="author sidebar__author">
        {avatarDiv}
        <div className="author-header">{defaultSignatureDiv}</div>
      </div>
    );
  }

  renderGroupUsers(users) {
    let avatarsDiv = [];
    let names = [];
    const limit = users.length <= 3 ? users.length : 3;

    for (let i = 0; i < limit; i++) {
      let { id, firstName, lastName, avatar, avatarUrl } = users[i];

      names.push(users.length < 2 ? firstName + " " + lastName : firstName);
      if (avatarUrl || avatar) {
        avatarsDiv.push(
          <div
            key={`user-${id}`}
            className="author-avatar"
            style={{
              backgroundImage: `url(${
                avatarUrl
                  ? addLandaSize(avatarUrl, 260)
                  : TTP_API_URL + "/" + avatar
              })`
            }}
          />
        );
      } else {
        avatarsDiv.push(
          <div key={`user-${id}`} className="author-avatar empty-avatar">
            <span>{getUserNameForAvatar(firstName, lastName)}</span>
          </div>
        );
      }
    }
    let other = 0;
    if (users.length > 3) {
      other = users.length - 3;
    }
    return (
      <div className="side__bar-group">
        <div
          className={`side__bar-group-avatar ${
            users.length > 3 ? "avatar-3" : "avatar-" + users.length
          }`}
        >
          {avatarsDiv}
        </div>
        <div className="side__bar-group-names">
          {names.join(users.length <= 3 ? " and " : ", ")}
          {other > 0 ? (
            <span>
              {" "}
              {_("and")}{" "}
              <strong>
                {other} {_("other user(s)")}.
              </strong>
            </span>
          ) : null}
        </div>
      </div>
    );
  }

  renderUsers() {
    const { users, selectedIds } = this.props;

    const selectedUsers = users.filter(
      user => selectedIds.indexOf(user.id) > -1
    );

    if (!selectedUsers || selectedUsers.length === 0) {
      // General settings
      return (
        <div className="sidebar__title">
          <span>{_("General settings")}</span>
        </div>
      );
    }

    // if (selectedUsers.length === 1) {
    //   return this.renderSingleUser(selectedUsers[0]);
    // } else {
    //   return this.renderGroupUsers(selectedUsers);
    // }
    return this.renderGroupUsers(selectedUsers);
  }

  setAllowLanguageValue(val, lng) {
    const { languages, allowedLanguages } = this.state;
    if (lng === "ALL") {
      this.setState({
        languages: val
          ? allowedLanguages.filter(lng => languages.includes(lng))
          : []
      });
      return;
    }

    this.setState({
      languages: val ? [...languages, lng] : languages.filter(l => l !== lng)
    });
  }

  setGeneralMediaType(val, type) {
    const { generalTypes } = this.state;

    if (type === "ALL") {
      this.setState({
        generalTypes: val ? ["IMAGE", "VIDEO", "PDF", "PPT"] : []
      });
      return;
    } else if (type === "DOCUMENTS") {
      this.setState({
        generalTypes: val
          ? [...generalTypes, "PDF", "PPT"]
          : generalTypes.filter(t => t !== "PDF" && t !== "PPT")
      });
    } else {
      this.setState({
        generalTypes: val
          ? [...generalTypes, type]
          : generalTypes.filter(t => t !== type)
      });
    }
  }

  isRolesChecked(roleType) {
    const { role } = this.state;
    return role === roleType;
  }

  setRoleType(val, role) {
    if (val) {
      this.setState({
        role: role
      });
    } else {
      this.setState({
        role: ""
      });
    }

    const { type, types, allowedType } = this.state;

    if (type === "ALL") {
      for (let t in allowedType) {
        types[t] = val ? role : "";
      }
    } else if (type === "DOCUMENTS") {
      types["PDF"] = val ? role : "";
      types["PPT"] = val ? role : "";
    } else if (type !== "") {
      types[type] = val ? role : "";
    }

    this.setState({ types: types, type: type });
  }

  setPublicProfile(val) {
    this.setState({ publicProfile: val });
  }

  setDefaultDataCopyright = e => {
    const { defaultData } = this.state;
    defaultData.copyright = e.currentTarget.value;

    this.setState({ defaultData: { ...defaultData } });
  };

  isTypesChecked = type => {
    const { types, role } = this.state;
    if (role !== "") {
      if (type === "ALL") {
        return ["IMAGE", "VIDEO", "PDF", "PPT"].every(t => types[t] === role);
      } else if (type === "DOCUMENTS") {
        return ["PDF", "PPT"].every(t => types[t] === role);
      } else {
        return types[type] === role;
      }
    } else {
      return false;
    }
  };

  setMediaType(val, type) {
    const { role, types, allowedType } = this.state;
    if (type === "ALL") {
      for (let t in allowedType) {
        types[t] = val ? role : "";
      }
      this.setState({
        type: type,
        types: { ...types }
      });
    } else if (type === "DOCUMENTS") {
      types["PDF"] = val ? role : "";
      types["PPT"] = val ? role : "";
      this.setState({
        type: type,
        types: { ...types }
      });
    } else {
      types[type] = val ? role : "";
      this.setState({
        type: type,
        types: { ...types }
      });
    }
  }

  isGeneralTypesChecked = type => {
    const { generalTypes } = this.state;

    if (type === "ALL") {
      return ["IMAGE", "VIDEO", "PDF", "PPT"].every(t =>
        generalTypes.includes(t)
      );
    } else if (type === "DOCUMENTS") {
      return ["PDF", "PPT"].every(t => generalTypes.includes(t));
    } else {
      return generalTypes.includes(type);
    }
  };

  renderGeneralMediaTypes() {
    return (
      <React.Fragment>
        <div className="separator">{_("Allowed media types")}</div>
        <div className="medias-switch">
          {["ALL", "IMAGE", "VIDEO", "DOCUMENTS"].map(type => (
            <div key={type} className="switch-w-input">
              <div className="switch-w-input__switch">
                <span className="sidebar_role">{_(type)}</span>
                <Switch
                  isChecked={this.isGeneralTypesChecked(type)}
                  onChange={val => this.setGeneralMediaType(val, type)}
                />
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }

  renderMediaTypes() {
    const { allowedType } = this.state;
    let switches;
    if (allowedType.length > 1) {
      switches = ["ALL", ...allowedType].map(type => (
        <div key={type} className="switch-w-input">
          <div className="switch-w-input__switch">
            <span className="sidebar_role">{_(type)}</span>
            <Switch
              isChecked={this.isTypesChecked(type)}
              onChange={val => this.setMediaType(val, type)}
            />
          </div>
        </div>
      ));
    } else {
      switches = (
        <div key={allowedType[0]} className="switch-w-input">
          <div className="switch-w-input__switch">
            <span className="sidebar_role">{_(allowedType[0])}</span>
            <Switch
              isChecked={this.isTypesChecked(allowedType[0])}
              onChange={val => this.setMediaType(val, allowedType[0])}
            />
          </div>
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className="separator">{_("Authorized media type")}</div>
        <div className="medias-switch">{switches}</div>
      </React.Fragment>
    );
  }

  renderRoleTypes() {
    return (
      <React.Fragment>
        <div className="separator">{_("Assigned role")}</div>
        <div className="medias-switch">
          {[
            "CHIEF_EDITOR",
            "AUTHOR_1",
            "AUTHOR_0",
            "REDACTOR_1",
            "REDACTOR_0"
          ].map(type => (
            <div key={type} className="switch-w-input">
              <div className="switch-w-input__switch">
                <span className="sidebar_role">{_(type)}</span>
                <Switch
                  name="media-type-preferences"
                  isChecked={this.isRolesChecked(type)}
                  onChange={val => this.setRoleType(val, type)}
                />
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }

  renderLanguages() {
    const { languages, allowedLanguages } = this.state;
    let swithes;
    if (allowedLanguages.length > 1) {
      swithes = ["ALL", ...allowedLanguages].map(lng => (
        <div key={lng} className="switch-w-input">
          <div className="switch-w-input__switch">
            <span className="sidebar_role">{_(lng)}</span>
            <Switch
              name="englishLng"
              keyAttr="english-language"
              isChecked={
                lng === "ALL"
                  ? allowedLanguages.every(lng => languages.includes(lng))
                  : languages.includes(lng)
              }
              onChange={val => this.setAllowLanguageValue(val, lng)}
            />
          </div>
        </div>
      ));
    } else {
      swithes = (
        <div key={allowedLanguages[0]} className="switch-w-input">
          <div className="switch-w-input__switch">
            <span className="sidebar_role">{_(allowedLanguages[0])}</span>
            <Switch
              name="englishLng"
              keyAttr="english-language"
              isChecked={languages.includes(allowedLanguages[0])}
              onChange={val =>
                this.setAllowLanguageValue(val, allowedLanguages[0])
              }
            />
          </div>
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className="separator">{_("Allowed languages")}</div>
        <div className="languages-switch">{swithes}</div>
      </React.Fragment>
    );
  }

  renderPublicProfile() {
    const { selectedIds } = this.props;
    const { publicProfile } = this.state;

    if (selectedIds.length > 0) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="separator">{_("Public Profile")}</div>
        <div className="profile-switch">
          <div className="switch-w-input">
            <div className="switch-w-input__switch">
              <span className="sidebar_role">{_("Public Profile")}</span>
              <Switch
                name="englishLng"
                keyAttr="english-language"
                isChecked={publicProfile}
                onChange={val => this.setPublicProfile(val)}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderDefaultData() {
    const { selectedIds } = this.props;
    const { defaultData } = this.state;

    if (selectedIds.length > 0) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="separator">{_("Default Data")}</div>
        <div className="copyright-switch">
          <textarea
            className="copyright"
            rows="3"
            value={defaultData.copyright}
            onChange={this.setDefaultDataCopyright}
            placeholder="copyright"
          />
        </div>
      </React.Fragment>
    );
  }

  handleClickMask = () => {
    this.props.dispatch(closeSidebar());
  };

  render() {
    const { fetched, updating, updated, selectedIds, opened } = this.props;

    if (!fetched) {
      return null;
    }

    const classes = classnames("sidebar", opened && "display");

    return (
      <div>
        <div
          id="settings__sidebar-mask"
          className={!opened ? "hide" : undefined}
          onClick={this.handleClickMask}
        />
        <div id="settings__sidebar" className={classes}>
          <div className="settings__close">
            <button onClick={this.handleClickMask}>
              <i className="icotam-close" />
            </button>
          </div>
          {this.renderUsers()}
          {selectedIds && selectedIds.length > 0
            ? this.renderRoleTypes()
            : null}

          {selectedIds && selectedIds.length > 0
            ? this.renderMediaTypes()
            : this.renderGeneralMediaTypes()}

          {this.renderLanguages()}
          {this.renderPublicProfile()}
          {this.renderDefaultData()}
          <Controls
            className={opened ? "display" : "default"}
            ok="Apply"
            cancel="Cancel"
            updated={updated}
            updating={updating}
            saveCallback={this.init.bind(this)}
            onCancel={this.handleClickMask}
            action={() => this.saveSettings()}
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  selectedIds: state.settings.selectedUsers,
  opened: state.settings.sidebarOpened,
  users: state.users.items,
  fetched: state.users.fetched,
  updating: state.users.updating,
  updated: state.users.updated,
  lng: state.params.lng,
  navCommunity: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  dispatch
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Settings/Sidebar.js